
                {
                    const el = document.createElement("style");
                    el.textContent = "\n.tooltip__trigger[data-v-7f344210] {\n  all: unset;\n}\n";
                    document.head.append(el);
                }